import { updateTheme } from "./updateTheme"
import { updateThemeWithoutTransitions } from "./updateThemeWithoutTransitions"

export let mediaQuery = window.matchMedia("(prefers-color-scheme: dark)")
document.documentElement.setAttribute("data-theme", updateTheme())
new MutationObserver(([{ oldValue }]) => {
  let newValue = document.documentElement.getAttribute("data-theme")
  if (newValue !== oldValue) {
    try {
      window.localStorage.setItem("theme", newValue)
    } catch {}
    updateThemeWithoutTransitions(newValue)
  }
}).observe(document.documentElement, { attributeFilter: ["data-theme"], attributeOldValue: true })
mediaQuery.addEventListener("change", updateThemeWithoutTransitions)
window.addEventListener("storage", updateThemeWithoutTransitions)
